import React from "react";
import { NavLink } from "react-router-dom";

const Breadcrumb = (props) => {
    return (
        <>
            <nav className="breadcrumb pd-0 mg-0 tx-12">
                {props.breadcrumb.map(item =>(
                    (item.path !==''?<NavLink key={item.name} to={item.path} className="breadcrumb-item">{item.name}</NavLink>:<span key={item.name} className="breadcrumb-item active">{item.name}</span>)                    
                ))}
            </nav>
        </>
    )
}

export default Breadcrumb;